import { css, cx } from "@emotion/css";
import { space, themeTokens, borderRadius, text } from "@octopusdeploy/design-system-tokens";
import { resetStyles } from "../../utils/resetStyles";

const navigationBarItemStyles = css({
    font: text.body.regular.medium,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",

    height: "2.25rem",
    minWidth: "2.25rem",

    borderRadius: borderRadius.small,

    background: "transparent",

    ":focus-visible": {
        background: themeTokens.color.navButton.background.hover,
        boxShadow: themeTokens.shadow.focused,
        zIndex: 1,
    },
    ":hover": {
        color: themeTokens.color.navButton.icon.hover,
        background: themeTokens.color.navButton.background.hover,
    },
    ":active": {
        color: themeTokens.color.navButton.icon.active,
        background: themeTokens.color.navButton.background.active,
    },
});

const navigationBarBaseLinkStyles = cx(
    css(resetStyles.anchor, {
        "&[aria-current=page]": {
            background: themeTokens.color.navButton.background.active,
        },
    }),
    navigationBarItemStyles
);

export const navigationBarTextLinkStyles = cx(
    navigationBarBaseLinkStyles,
    css({
        paddingInlineStart: space[12],
        paddingInlineEnd: space[12],
    })
);
export const navigationBarIconLinkStyles = navigationBarBaseLinkStyles;

const navigationBarBaseButtonStyles = cx(
    css(resetStyles.button, {
        "&[aria-expanded=true]": {
            color: themeTokens.color.navButton.icon.active,
            background: themeTokens.color.navButton.background.active,
        },
    }),
    navigationBarItemStyles
);

export const navigationBarTextButtonStyles = cx(
    navigationBarBaseButtonStyles,
    css({
        paddingInlineStart: space[12],
        paddingInlineEnd: space[12],
        gap: space[8],
    })
);
export const navigationBarIconButtonStyles = navigationBarBaseButtonStyles;
